<template>
  <div class="popup" v-show="visible">
    <div class="popup--inner">
      <h2 class="popup--title">Edit Recurring Blocked Timeslot</h2>
      <form novalidate v-on:submit.prevent="() => {return false}" class="popup--paragraph">
        <Message v-if="error" :message-content="error" message-status="error"></Message>
        <fieldset class="form--item">
          <label class="label" for>Weekday:</label>
          <div class="input_text" id>
            <v-select
              v-model="dayId"
              required
              :searchable="false"
              placeholder="Select a day"
              :options="days"
            ></v-select>
          </div>
        </fieldset>
        <fieldset class="form--item">
          <label class="label" for>Start time</label>
          <div class="input_text" id="link">
            <el-time-select
              v-model="starttime"
              :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '23:30'
                        }"
              placeholder="Click to select a start timeslot"
            ></el-time-select>
          </div>
        </fieldset>
        <fieldset class="form--item">
          <label class="label" for>End time</label>
          <div class="input_text" id="link">
            <el-time-select
              v-model="endtime"
              :picker-options="{
                            start: '00:00',
                            step: '00:15',
                            end: '23:45',
                            minTime: starttime
                        }"
              placeholder="Click to select a end timeslot"
            ></el-time-select>
          </div>
        </fieldset>
      </form>
      <div class="popup--buttons">
        <a class="popup--buttons-item btn btn_grey btn_stroke" v-on:click="close">Cancel</a>
        <a class="popup--buttons-item btn btn_green" v-on:click="validateBlock">Save</a>
      </div>
    </div>
  </div>
</template>
<script>
import Popup from "vue-popup";
import Message from "../Message";
import vSelect from "vue-select";

import { ObjectID } from "bson";
var moment = require("moment");
require("vue-popup/lib/popup.css");
export default {
  mixins: [Popup],
  components: { Message, vSelect },
  props: {
    visible: false,
    resource: "",
    modal: {
      default: true
    },
    block: {},
    closeOnClickModal: {
      default: true
    }
  },
  data() {
    return {
      error: "",
      recurringBlockedTimeslot: {},
      days: [
        { value: 0, label: "Sunday" },
        { value: 1, label: "Monday" },
        { value: 2, label: "Tuesday" },
        { value: 3, label: "Wednesday" },
        { value: 4, label: "Thursday" },
        { value: 5, label: "Friday" },
        { value: 6, label: "Saturday" }
      ],
      dayId: 0,
      starttime: "",
      endtime: ""
    };
  },
  watch: {
    visible: function(newVal, oldVal) {
      // watch it
      if (newVal && !this.block.id) {
        this.recurringBlockedTimeslot = {};
        this.dayId = this.days[0];
        this.starttime = "";
        this.endtime = "";
      } else if (newVal) {
        this.recurringBlockedTimeslot = JSON.parse(JSON.stringify(this.block));
        this.dayId = this.days[this.recurringBlockedTimeslot.dayId];
        this.starttime = this.convertTimeslot(
          this.recurringBlockedTimeslot.startSlot
        );
        this.endtime = this.convertTimeslot(
          this.recurringBlockedTimeslot.endSlot
        );
      }
    }
  },
  methods: {
    close() {
      this.$parent.toggleRecurringBlockedTimeslotBlock();
    },
    confirm() {
      this.recurringBlockedTimeslot.formatted_value = this.format();
      this.recurringBlockedTimeslot.dayId = this.dayId.value;
      this.recurringBlockedTimeslot.startSlot = this.getTimeslot(
        this.starttime
      );
      this.recurringBlockedTimeslot.endSlot = this.getTimeslot(this.endtime);
      this.recurringBlockedTimeslot.id =
        this.recurringBlockedTimeslot.id || new ObjectID().toString();
      this.$parent.addRecurringBlockedTimeslotBlock(
        this.recurringBlockedTimeslot
      );
    },
    isOverlapping() {
      let items = this.$parent.wall.recurringBlockedTimeslots || [];
      this.recurringBlockedTimeslot.dayId = this.dayId.value;
      this.recurringBlockedTimeslot.startSlot = this.getTimeslot(
        this.starttime
      );
      this.recurringBlockedTimeslot.endSlot = this.getTimeslot(this.endtime);
      for (var i = items.length - 1; i >= 0; i--) {
        if (
          Math.max(
            items[i].startSlot,
            this.recurringBlockedTimeslot.startSlot
          ) <
            Math.min(items[i].endSlot, this.recurringBlockedTimeslot.endSlot) &&
          this.recurringBlockedTimeslot.id != items[i].id &&
          this.recurringBlockedTimeslot.dayId == items[i].dayId
        ) {
          this.error =
            "The time you selected overlaps another block which is not allowed";
          return true;
        }
      }
      this.error = "";
      return false;
    },
    validateBlock() {
      if (
        !(this.starttime && this.endtime && this.dayId) ||
        this.isOverlapping()
      ) {
        return false;
      }
      this.error = "";
      return this.confirm();
    },
    getTimeslot(datetime) {
      let time = datetime.split(":");
      let slot = time[0] * 4 + time[1] / 15;
      return ("00" + slot).slice(-2);
    },
    convertTimeslot(datetime) {
      return (
        ("00" + Math.floor(parseInt(datetime) / 4)).slice(-2) +
        ":" +
        ("00" + ((parseInt(datetime) * 15) % 60)).slice(-2)
      );
    },
    format(val) {
      return (
        this.dayId.label +
        " - " +
        moment(this.starttime, "hh:mm").format("hh:mma") +
        " to " +
        moment(this.endtime, "hh:mm").format("hh:mma")
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// modal_recurring_blocked_timeslot.vue?58796bbe